import React from 'react';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import UploadZip from './add/Upload';

const ThemesZipValidationDashboard: React.FC = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.themesZipValidation}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.themesZipValidation].addData]}
				configPageName={PAGE_NAMES.dashboard}
				component={UploadZip}
				exact
			/>
			<Redirect to={`${path}/themesZipValidation`} />
		</Switch>
	);
};

export default ThemesZipValidationDashboard;
